import React from 'react'

import { Icon, Warning } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

const iconSize = { height: '20px', width: '20px' }

// Single-line banner shown between the filters row and the card grid on the
// landing page when a too-narrow filter falls back to popular models. Mirrors
// Figma "message" node 5711:460397: a leading warning glyph and one line of
// body-md-semibold text where "clearing filters" is an inline link that resets
// the filters. Results stay visible below, so the page never dead-ends.
function NoMatchNotice({ onClearFilters = NOOP }) {
  return (
    <div className="community-gallery-no-match-notice" role="status">
      <span className="community-gallery-no-match-notice__icon" aria-hidden="true">
        <Icon svgComponent={Warning} size={iconSize} />
      </span>
      <p className="community-gallery-no-match-notice__text cgt-body-md-semibold">
        No models found matching your criteria. Try
        {' '}
        <button
          type="button"
          className="community-gallery-no-match-notice__link"
          onClick={onClearFilters}
        >
          clearing filters
        </button>
        {' '}
        and adjusting your search, or explore popular suggestions below.
      </p>
    </div>
  )
}

NoMatchNotice.propTypes = {
  onClearFilters: func,
}

export default NoMatchNotice
